const RouteUrls = {
  appHome: '/',
  home: '/home',
  login: '/login',
  reward: '/reward',
  categories: '/categories',
  piggyBankBalance: '/piggy-bank-balance',
  piggyBankTransactions: '/piggy-bank-transactions',
  rewardDashboard: '/reward-dashboard',
  aboutPage: '/about',
  profile: '/profile',
  reedem: '/redeem',
  signup: '/signup',
  forgotPassword: '/forgot-password',
  checkEmail: '/check-email',
  resetPassword: '/reset-password',
  passwordChangeSuccess: '/password-change-success',
  linkExpired: '/link-expired',
  emailVerification: '/email-verification',
  settings: '/settings'
};

export default RouteUrls;
